<div class="filterTable">
  <div class="resizable-row">
    @if (isStateActive) {
      <mat-form-field class="filterField" id="statusField">
        <mat-label>Status</mat-label>
        <mat-select
          #statusSelect
          [(value)]="status"
          (selectionChange)="getStatusSelection($event)"
        >
          @for (value of statusValues; track value) {
            <mat-option [value]="value">
              {{ value }}
            </mat-option>
          }
        </mat-select>
        @if (canStatusFilterBeRemoved) {
          <button
            id="statusButton"
            (click)="clearDropDownFieldEvent($event)"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    @if (hideOriginFilter && !isAccountTypeManagementOnly) {
      <mat-form-field class="filterField" id="originFilter">
        <mat-label>Origin</mat-label>
        <mat-select
          #originSelect
          [(value)]="origin"
          (selectionChange)="getOriginSelection($event)"
        >
          @for (value of originValues; track value) {
            <mat-option [value]="value">
              {{ value }}
            </mat-option>
          }
        </mat-select>
        @if (filterFormToSend.origin) {
          <button
            id="originButton"
            (click)="clearDropDownFieldEvent($event)"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <mat-form-field class="filterField" id="inspectionIdField">
      <mat-label>Id</mat-label>
      <input
        #first
        [(ngModel)]="inspectionIdField"
        (keypress)="ValidateKeyCode($event)"
        matInput
        autocomplete="off"
      />
      @if (inspectionIdField) {
        <button (click)="clearInspectionIdField()" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <mat-form-field class="filterField" id="clientField">
      <mat-label>Client</mat-label>
      <input #first [(ngModel)]="clientField" matInput />
      @if (clientField) {
        <button (click)="clearClientField()" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (!isAccountTypeManagementOnly) {
      <mat-form-field class="filterField" id="referenceFilter">
        <mat-label>Inspect. Reference</mat-label>
        <input #first [(ngModel)]="inspectionReferenceField" matInput />
        @if (inspectionReferenceField) {
          <button
            (click)="clearInspectionReferenceField()"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    @if (!isOnlyInspector()) {
      <mat-form-field class="filterField" id="typeFilter">
        <mat-label>Type</mat-label>
        <mat-select
          #typeSelect
          [(value)]="type"
          (selectionChange)="getTypeSelection($event)"
        >
          @for (value of typeValues; track value) {
            <mat-option [value]="value.id">
              {{ value.name }}
            </mat-option>
          }
        </mat-select>
        @if (filterFormToSend.type) {
          <button
            id="typeButton"
            (click)="clearDropDownFieldEvent($event)"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <mat-form-field class="filterField" id="inspectionDateFilter">
      <mat-label>Inspection Date</mat-label>
      <mat-date-range-input [rangePicker]="picker1">
        <input [(ngModel)]="dateFrom" matStartDate placeholder="Start date" />
        <input [(ngModel)]="dateTo" matEndDate placeholder="End date" />
      </mat-date-range-input>
      <mat-datepicker-toggle
        [for]="picker1"
        matIconSuffix
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker1></mat-date-range-picker>
      @if (dateTo) {
        <button (click)="clearInspectionDateField()" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <mat-form-field class="filterField" id="creationDateFilter">
      <mat-label>Creation Date</mat-label>
      <mat-date-range-input [rangePicker]="picker2">
        <input
          [(ngModel)]="creationDateFrom"
          matStartDate
          placeholder="Start date"
        />
        <input [(ngModel)]="creationDateTo" matEndDate placeholder="End date" />
      </mat-date-range-input>
      <mat-datepicker-toggle
        [for]="picker2"
        matIconSuffix
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker2></mat-date-range-picker>
      @if (creationDateTo) {
        <button (click)="clearCreationDateField()" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (!isStateActive) {
      <mat-form-field class="filterField" id="closeDateFilter">
        <mat-label>Closing Date</mat-label>
        <input [(ngModel)]="closeDate" [matDatepicker]="picker3" matInput />
        <mat-datepicker-toggle [for]="picker3" matSuffix>
        </mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
        @if (closeDate) {
          <button (click)="clearCloseDateField()" mat-icon-button matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    @if (!isAccountTypeManagementOnly) {
      <mat-form-field class="filterField" id="vesselNameFilter">
        <mat-label>Vessel Name</mat-label>
        <input
          #first
          [(ngModel)]="vesselNameFilter"
          (keypress)="ValidateKeyCode($event)"
          matInput
          autocomplete="off"
        />
        @if (vesselNameFilter) {
          <button (click)="clearVesselNameField()" mat-icon-button matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    @if (!isInspectionsOnlyAccount) {
      <mat-form-field class="filterField" id="timesheetStatusField">
        <mat-label>Timesheet Status</mat-label>
        <mat-select
          #timesheetStatusSelect
          [(value)]="timesheetStatus"
          (selectionChange)="getTimesheetStatusSelection($event)"
        >
          @for (value of timesheetStatusValues; track value) {
            <mat-option [value]="value">
              {{ getTimesheetStatusLabel(value) }}
            </mat-option>
          }
        </mat-select>
        @if (filterFormToSend.timeManagementState != "") {
          <button
            id="timesheetStatusButton"
            (click)="clearDropDownFieldEvent($event)"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
  <button
    class="moreFiltersButton"
    (click)="openAdditionalFiltersDialog()"
    mat-button
  >
    <mat-icon>filter_list</mat-icon>
    MORE FILTERS
  </button>
</div>

<div class="buttonsContainer">
  <button
    id="searchButton"
    [disabled]="disableSearchButton"
    (click)="onSearchClick()"
    mat-button
  >
    <mat-icon>search</mat-icon>
    SEARCH
  </button>
  <button id="clearButton" (click)="onClearFilters()" mat-icon-button>
    <mat-icon>cleaning_services</mat-icon>
  </button>
</div>
